import { inject } from "vue"
import { handleError } from "@shared/helpers/utils"

export const usePeople = () => {
  const axios: any = inject("$baseHttpClient")

  const saveCulture = async (language: string): Promise<boolean> => {
    try {
      const response = await axios.put("/People/SaveCulture", { value: language })
      if (!response.data.success) {
        handleError(response.data.error)
        return false
      }
      return true
    } catch (error) {
      handleError(error)
      throw error
    }
  }

  return {
    saveCulture,
  }
}
